import styled from 'styled-components';
import { flexCenter, media } from '@anm/styles/helpers';

const currentPlanLoaderWrapperMobile = media.phone`
  min-height: 345px;
`;

export const CurrentPlanLoaderWrapper = styled.div`
  border: 1px solid #ccdde6;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgb(1 83 130 / 10%);
  flex: 1;
  ${flexCenter};
  ${currentPlanLoaderWrapperMobile};
`;
